import { gql } from '@apollo/client'

const PRODUCT_FIELDS = gql`
  fragment ProductTableFields on Product {
    gps_status
    campaign_id
    configuration
    name
    active
    publish_date
    parent_id
    id
    dsp_updates
    radio_updates
    gpid_list
  }
`

export const GET_PROJECT = gql`
  query ($id: String!) {
    getCampaign(id: $id) {
      id
      name
      unit_id
      owner_id
      global_status
      isaac_url {
        title
        url
      }
      info
      team_info
      active
      user {
        id
        email
        first_name
        last_name
      }
      artist {
        name
        opus_id
        gps_status
        facebook_id
        spotify_id
      }
    }
  }
`

export const GET_PRODUCTS_BY_CAMPAIGN = gql`
  ${PRODUCT_FIELDS}
  query ($campaignId: String!, $countryCode: String) {
    getProductsByCampaignId(campaignId: $campaignId, countryCode: $countryCode) {
      ...ProductTableFields
      alter_names {
        id
        artist_name
        product_name
        product_id
      }
    }
  }
`
export const CREATE_PRODUCT = gql`
  mutation ($input: [ProductCreate]) {
    createProducts(input: $input) {
      active
      campaign_id
      configuration
      gps_status
      gpid_list
      id
      name
      publish_date
    }
  }
`

export const CREATE_LOCAL_PRODUCT = gql`
  ${PRODUCT_FIELDS}
  mutation ($input: ProductLocalCreateInput) {
    createLocalProduct(input: $input) {
      ...ProductTableFields
    }
  }
`

export const UPDATE_PRODUCT = gql`
  ${PRODUCT_FIELDS}
  mutation ($input: ProductUpdate) {
    updateProduct(input: $input) {
      ...ProductTableFields
    }
  }
`

export const REMOVE_LOCAL_PRODUCT = gql`
  ${PRODUCT_FIELDS}
  mutation ($id: String!) {
    removeLocalProduct(id: $id) {
      ...ProductTableFields
    }
  }
`

export const SEARCH_DV_PRODUCTS = gql`
  query ($productName: String!, $configuration: ArtistProductType!) {
    searchProducts(productName: $productName, configuration: $configuration) {
      total
      products {
        gpid_list
        primaryArtistName
        name
        type
        release_date
      }
    }
  }
`

export const GET_ARTIST_PRODUCTS = gql`
  query ($artist_id: String!, $name: String!) {
    getArtistProducts(artist_id: $artist_id, name: $name) {
      id
      name
      gps_status
      configuration
      locals {
        id
        label_id
        campaign_id
      }
    }
  }
`
export const UPDATE_PROJECT = gql`
  mutation ($input: CampaignUpdate) {
    updateCampaign(input: $input) {
      artist_id
      global_status
      id
      info
      isaac_url {
        title
        url
      }
      label_id
      main_product_id
      name
      owner_id
      project_id
      team_info
      unit_id
    }
  }
`

export const DELETE_PROJECT = gql`
  mutation ($id: String!) {
    removeCampaign(id: $id) {
      id
    }
  }
`

export const ARCHIVE_PROJECT = gql`
  mutation ($id: String!) {
    archiveCampaign(id: $id) {
      id
    }
  }
`

export const ACTIVATE_PROJECT = gql`
  mutation ($id: String!) {
    activateCampaign(id: $id) {
      id
    }
  }
`

export const UPDATE_ARTIST = gql`
  mutation ($input: ArtistUpdate) {
    updateArtist(input: $input) {
      id
      label_id
      gps_status
    }
  }
`

export const REMOVE_ALTER_NAME = gql`
  mutation ($id: String!) {
    removeAlterName(id: $id) {
      id
      artist_name
      product_id
      product_name
    }
  }
`

export const CREATE_ALTER_NAME = gql`
  mutation ($input: AlterNameCreate) {
    createAlterName(input: $input) {
      id
      artist_name
      product_id
      product_name
    }
  }
`

export const FIND_USER_BY_EMAIL = gql`
  query ($email: String!) {
    findUserByEmail(email: $email) {
      abilities {
        canCreateCampaign
        canChangeCampaignUnit
      }
      id
      email
    }
  }
`

export const FIND_USER_BY_ID = gql`
  query ($id: Int!) {
    getUser(id: $id) {
      abilities {
        canCreateCampaign
        canChangeCampaignUnit
      }
      id
      email
    }
  }
`
